import { render } from "./KodAkaun.vue?vue&type=template&id=345f0f0e"
import script from "./KodAkaun.vue?vue&type=script&lang=js"
export * from "./KodAkaun.vue?vue&type=script&lang=js"

import "./KodAkaun.vue?vue&type=style&index=0&id=345f0f0e&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__